import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

//Declaring global variables. This variables will be used in all the app process
window.$apiEndpoint = 'https://api.falcotraslochi.it/api/v1' //Backend
window.$fileserverEndpoint = 'https://fs.falcotraslochi.it' //Fileserver
window.$fileserverEndpointCrop = 'https://fs.falcotraslochi.it' //Fileserver End Poit for Crop Image




ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
